import React, { useEffect, useState } from 'react'
import "./modal.css"
import {Modal, Box, Typography, Button} from "@material-ui/core"
import axios from 'axios';
import { img_500, unavailable } from '../config/config';
import Carousel from '../Carousel/Carousel';
import { YouTube, CloseOutlined } from '@material-ui/icons';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "70%",
  height: "80%",
  bgcolor: 'purple',
  color: "white",
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
};

// modal with movie's detail information
const ModalContent = ({open, handleClose, movieID, mediaType="movie"}) => {
  const [content, setContent] = useState([])
  const [video, setVideo] = useState("")

  const fetchData = () => { // fetch selected movie data
    axios.get(`https://api.themoviedb.org/3/${mediaType}/${movieID}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`)
      .then(res => {
        // console.log(res.data)
        setContent(res.data)
      })
      .catch(err => {
        console.log(err)
      })
  }
  const fetchVideo = () => {
    axios.get(`https://api.themoviedb.org/3/${mediaType}/${movieID}/videos?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`)
      .then(res => {
        // console.log(res.data)
        setVideo(res.data.results[0]?.key)
      })
      .catch(err => {
        console.log(err)
      })
  }
  useEffect(() => {
    fetchData()
    fetchVideo()
  }, [])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className='box'>
        <div className="close-btn" onClick={handleClose}>
          <CloseOutlined />
        </div>
        <div className='content'>
          <img src={content.poster_path?`${img_500}/${content.poster_path}`:unavailable} alt="" 
            className='img-landscape' />
          <div className="info">
            <h1 className='title'>{content.title || content.original_name}</h1>
            <h4 className='date'>Release date: {content.release_date}</h4>
            <h4 className='rating'>Rating: {content.vote_average}</h4>
            {/* {console.log(content.genres[0])} */}
            <div className='genres'>
              <h4>Categories:</h4> 
              {content.genres?.map((g, i) => {
                return <i key={i} className="genre">{g.name}</i>
              })}
            </div>            
            <div className="countries">
              <h4>Countries: </h4> 
              {/* {console.log(content.production_countries[0].name)} */}
              {content.production_countries && content.production_countries.map((c, i) => {
                return <i key={i}> {c.name}, </i>
              })}
            </div>
            <p className='overview'>{content.overview}</p>
            <Carousel id={movieID} mediaType={mediaType} />
            <Button className='video-btn' color="secondary"
              startIcon={<YouTube />} style={{backgroundColor:"white"}} 
              target="_blank" href={`https://www.youtube.com/watch?v=${video}`} >
              WATCH THE TRAILER
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalContent
